<app-base-modal
  [open]="isOpen()"
  (openChange)="onOpenChange($event)"
  title="Add papers"
  [size]="'lg'"
>
  @if (isOpen()) {
    <div class="flex flex-col gap-3" data-testid="add-papers-dialog">
      <app-source-picker
        [selected]="selectedSource()"
        (change)="onSourceChange($event)"
      ></app-source-picker>

      <div class="flex-1 overflow-y-auto pt-2">
        @switch (selectedSource()) {
          @case ('OPENALEX') {
            <app-openalex-form (done)="onFormDone()"></app-openalex-form>
          }
          @case ('BIBTEX') {
            <app-bibtex-form (done)="onFormDone()"></app-bibtex-form>
          }
          @case ('PDF') {
            <app-pdf-form (done)="onFormDone()"></app-pdf-form>
          }
          @case ('GROUP_CORPUS') {
            <app-group-corpus-form (done)="onFormDone()"></app-group-corpus-form>
          }
        }
      </div>
    </div>
  }
</app-base-modal>
